import React from 'react'
import { H3, Subheading } from '@fs/zion-ui'

export default ({ label, description }) => (
  <H3 size="H6">
    {label}
    <Subheading>{description}</Subheading>
  </H3>
)
